import React from "react";
import { ReportTableWidget } from "../components/ReportTable/ReportWidget";
import { DashboardFilters } from "../components/Filters/Filters";
import { Space, Divider, Form } from "antd";
import { TableTotals } from "../components/Totals/TableTotals";
import { CollapsebleChart } from "../components/Charts/LineChart";
import { usePromoData, GroupSelect } from "./Promos";
import { allLandingsColumns } from "../constants";
import { PageTemplate } from "./PageTemplate";
import { useGeneralReportListFile } from "../apiHooks";
import { ExcelButton } from "../components/Filters/ExcelButton";

export const Landings = () => {
  const {
    isLoading,
    data,
    totals,
    promoOptions,
    chartFilters,
    showPromoField,
    reqFilters,
  } = usePromoData({
    day: "by-days-landings",
    total: "by-landings",
  });

  const [getFile, { isLoading: isFileLoading }] = useGeneralReportListFile(
    reqFilters as any
  );
  const clickHandler = () => {
    getFile();
  };

  return (
    <PageTemplate>
      <Space
        size={0}
        direction="vertical"
        style={{ width: "100%", display: "flex" }}
      >
        <DashboardFilters
          fields={
            <>
              {showPromoField && (
                <Form.Item name="promo_id">
                  <GroupSelect
                    defaultValue={null}
                    style={{ minWidth: 200, maxWidth: 300 }}
                    loading={isLoading}
                    allowClear={false}
                    options={promoOptions}
                    showSearch
                    optionFilterProp={"search"}
                  />
                </Form.Item>
              )}
              <ExcelButton
                clickHandler={clickHandler}
                isLoading={isFileLoading}
              />
            </>
          }
        />
        <Divider style={{ margin: 0 }} />
        <CollapsebleChart filters={chartFilters} />
      </Space>

      <TableTotals totals={totals} isLoading={isLoading} />
      <ReportTableWidget
        data={data}
        isLoading={isLoading}
        allColumns={allLandingsColumns}
        showGroupBy
        date={reqFilters}
      />
    </PageTemplate>
  );
};
